import { isQueueKey } from './index';
import { QueueKey } from 'flow/types/EntityKeys';
import { QueueSortingData } from 'flow/types/Pbx';
import { TypedMap } from 'flow/types/TypedMap';
import { sortStrings } from 'flow/utils/sorter-utils';
import { List } from 'immutable';

export const isTypeQueueKey = (key?: string): key is QueueKey =>
    isQueueKey(key);

// Typed counterpart of sortPbxServices in pbx-sorting-utils.js: sorts a keyed
// map of pbx services alphabetically by description, preserving the element
// type so callers get an inferred List<TypedMap<T>> back.
export const sortPbxServices = <
    K extends string,
    T extends { description: string },
>(
    services?: TypedMap<Record<K, TypedMap<T>>>,
): List<TypedMap<T>> => {
    if (!services) return List();

    return services
        .valueSeq()
        .sort((service1, service2) =>
            sortStrings(
                service1.get('description'),
                service2.get('description'),
            ),
        )
        .toList();
};

export const sortQueuesSortingData = (
    queues?: TypedMap<Record<QueueKey, TypedMap<QueueSortingData>>>,
): List<TypedMap<QueueSortingData>> => {
    if (!queues) return List();

    const queuesUserIsMemberOf = queues.filter((queue) =>
        queue.get('ownExtensionIsMember'),
    );

    const queuesUserIsNotMemberOf = queues.filter(
        (queue) => !queue.get('ownExtensionIsMember'),
    );

    return sortPbxServices(queuesUserIsMemberOf)
        .concat(sortPbxServices(queuesUserIsNotMemberOf))
        .toList();
};
